import _ from 'underscore';
import BaseDispatcher from './dispatcher.js';

const Dispatcher = _.extend(BaseDispatcher.prototype, {
  handleAppAction(action) {
    this.dispatch({ source: 'APP_ACTION', action });
  },

  handleModalAction(action) {
    this.dispatch({ source: 'MODAL_ACTION', action });
  },

  handleSidemenuAction(action) {
    this.dispatch({ source: 'SIDEMENU_ACTION', action });
  },

  handleTourWizardAction(action) {
    this.dispatch({ source: 'TOUR_WIZARD_ACTION', action });
  },

  handlePhotoUploadAction(action) {
    this.dispatch({ source: 'PHOTO_UPLOAD_ACTION', action });
  },

  handlePhotoAction(action) {
    this.dispatch({ source: 'PHOTO_ACTION', action });
  },

  handleTitlebarAction(action) {
    this.dispatch({ source: 'TITLEBAR_ACTION', action });
  },

  handleOnboardingAction(action) {
    this.dispatch({ source: 'ONBOARDING_ACTION', action });
  },

  handleNotificationAction(action) {
    this.dispatch({ source: 'NOTIFICATION_ACTION', action });
  },

  handleUserOverviewAction(action) {
    this.dispatch({ source: 'USER_OVERVIEW_ACTION', action });
  },
});

export default Dispatcher;
